module.exports = __webpack_public_path__ + "img/africa.a978aaec.png";